export default {
  START_AUDIO_TRACKER: 'startAudioTrack',
  STOP_AUDIO_TRACKER: 'stopAudioTrack',
  START_POSITION_TRACKER: 'startPositionTrack',
  START_DELAYED_POSITION_TRACKER: 'startDelayedPositionTrack',
  STOP_POSITION_TRACKER: 'stopPositionTrack'
};
